export default IconServicemark => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-servicemark" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M9 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5" />
  <path d="M13 15v-6l3 4l3 -4v6" />
</svg>`;